import {HIDE_UPGRADE_CARD_MODAL, SHOW_UPGRADE_CARD_MODAL} from "../actions";

const initState = {
  source: '',
  show: false
};

export default (state = initState, action) => {
  switch (action.type) {
    case HIDE_UPGRADE_CARD_MODAL:
      return {
        show: false
      };
    case SHOW_UPGRADE_CARD_MODAL:
      return {
        ...state,
        ...action.payload,
        show: true
      };
    default: return state;
  }
};